import { render, staticRenderFns } from "./PromoProjectSelect.vue?vue&type=template&id=5fd30b79&scoped=true"
import script from "./PromoProjectSelect.vue?vue&type=script&lang=ts"
export * from "./PromoProjectSelect.vue?vue&type=script&lang=ts"
import style0 from "./PromoProjectSelect.vue?vue&type=style&index=0&id=5fd30b79&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd30b79",
  null
  
)

export default component.exports